import { isProductionDeployment } from "../../../utils/isProductionDeployment";

export const VIEWSPARK_SIGN_IN_URL = "https://adminportal.viewspark.com/";

export const ALPHA_LOGIN_CALLOUT = {
  headline: "Trying to sign in to ViewSpark?",
  body: "This is the development version of ViewSpark, available only for our IT team. If you're trying to use the ViewSpark Admin Portal, please click the button below.",
  action: "Go to ViewSpark Sign In",
};

export const ALPHA_LOGIN_REDIRECT_MODAL = {
  title: "Let's get you to the right sign-in page",
  body:
    "It seems like you're trying to sign in to the ViewSpark Admin Portal. Since this is the development version, please click Continue to be redirected and use the correct sign-in page.",
  action: "Continue",
};

export type AlphaLoginFailureSource =
  | "passwordRequest"
  | "configLoad"
  | "firebaseToken"
  | "otp";

/** Whether this sign-in page should steer users from hosted alpha to production. */
export function shouldShowAlphaLoginSafeguard(): boolean {
  const hostname =
    typeof window === "undefined" ? undefined : window.location?.hostname;
  const isLocal = ["localhost", "127.0.0.1", "::1", "[::1]"].includes(
    hostname || ""
  );
  return !isLocal && !isProductionDeployment();
}

export function shouldOpenAlphaLoginRedirect(
  source: AlphaLoginFailureSource
): boolean {
  return source === "passwordRequest" && shouldShowAlphaLoginSafeguard();
}

export function goToViewSparkSignIn(): void {
  window.location.assign(VIEWSPARK_SIGN_IN_URL);
}
